import React from 'react'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import { useIntl } from 'react-intl'

interface Props {
  saleUnit: string
}

function InvalidSelectionBanner({ saleUnit }: Props) {
  const intl = useIntl()

  return (
    <MessageBanner
      kind="warning"
      density="compact"
    >
      {intl.formatMessage(
        {
          id: '37vtrQ3ViI',
          defaultMessage: 'Your previous {saleUnit} selection is no longer available, please review your new selection.',
          description: 'Warning banner shown when a previously selected room/package is no longer available',
        },
        { saleUnit },
      )}
    </MessageBanner>
  )
}

export default InvalidSelectionBanner
